<!--
 * @Author: your name
 * @Date: 2021-05-25 17:06:47
 * @LastEditTime: 2021-05-26 09:48:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\components\newfile\new4.vue
-->


<template>
  <div class="new1">
      
<p style="text-align:center">
    <strong><span style="font-family: 宋体;font-size: 24px"><br/></span></strong>
</p>
<p style="text-align: center;">
    <strong><span style="font-family: 宋体;font-size: 24px">门站通气试运行 &nbsp;&nbsp;六景用户有福“气”</span></strong><br/>
</p>
<p style="text-indent:80px;text-align: center;">
    <span style=";font-family:宋体;font-size:20px"><span style="font-family:宋体">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;——南宁神州燃气有限公司六景门站顺利通气试运行</span></span>
</p>
<p style="text-indent:40px">
    <span style=";font-family:Calibri;font-size:20px">&nbsp;</span>
</p>
<p style="text-indent:47px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:Calibri">9</span><span style="font-family:宋体">月</span><span style="font-family:Calibri">10</span><span style="font-family:宋体">日上午</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:Calibri">10:00</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">，南宁神州燃气有限公司六景门站内热闹非凡，中石化管道天然气六景接气工程通气试运行仪式在此隆重举行。仪式由神州能源集团股份有限公司总裁谭佐龙主持。广西燃气集团董事长、中石化广西管道公司、中石化广西天然气销售公司总经理朱圣平；神州能源集团股份有限公司董事长刘湛、顾问刘明燕、常务副总裁张德权、总工程师崔国华，横县各有关部门领导，六景工业园区领导，园区企业代表等</span><span style="font-family:Calibri">50</span><span style="font-family:宋体">余人参加了通气仪式。</span></span>
</p>
<p style="text-align:center">
    <img width="553" height="369" src="../../assets/Information/zx11.png" style="background:url(../../assets/Information/zx11.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">刘湛董事长在仪式上发表讲话，代表公司对横县人民政府、中石化广西管道公司以及项目建设者门表示感谢和敬意。同时他表示，神州能源集团将始终秉承</span><span style="font-family:宋体">“安全发展，福泽社会”的企业使命，践行社会责任，实现天然气安全稳定供应，为六景工业园区经济可持续发展提供能源支持和保障。</span></span>
</p>
<p style="text-align: center;">
    <img width="553" height="369" src="../../assets/Information/zx12.png" word_img="../../assets/Information/zx12.png" style="background:url(../../assets/Information/zx12.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">随后，神州能源集团董事长刘湛、广西燃气集团董事长朱圣平、县住建局副局长梁桂共同开启阀门实现通气。</span></span>
</p>
<p style="text-align:center">
    <img width="553" height="369" src="../../assets/Information/zx13.png" style="background:url(../../assets/Information/zx13.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">中石化管道天然气六景接气工程是六景工业园区基础设施建设的重点工程之一。项目建设用地</span>5000<span style="font-family:宋体">平方米，建筑面积</span><span style="font-family:Calibri">471.14</span><span style="font-family:宋体">平方米，总投资</span><span style="font-family:Calibri">5</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:Calibri">000</span><span style="font-family:宋体">余</span></span><span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">万元，建成后具有日供气量</span>50<span style="font-family:宋体">万立方米的能力，可满足六景工业园区正常用气。</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">六景门站</span></span><span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">作为中石化广西管道第一家由县级燃气公司直接在分输阀室连头通气的项目，</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">它的通气运行，实现了横县天然气县县通。</span></span><span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">结束了六景工业园区无管道天然气应用的历史，为园区可持续发展提供了能源保障，让用户用上了安全、洁净、经济、方便的管道天然气</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">，把推进广西天然气管网互联互通和天然气产业发展落到实处</span></span><span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">。</span></span>
</p>
<p style="text-align: center;">
    <img width="553" height="250" src="../../assets/Information/zx14.png" style="background:url(../../assets/Information/zx14.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">六景接气工程的通气运营标志着横县管道燃气事业发展进入到一个崭新的阶段，在提升城市投资环境、健全园区功能、改善园区营商和生态环境等方面发挥着重要的作用。</span></span>
</p>
<p style="text-align: center;">
    <img width="553" height="369" src="../../assets/Information/zx15.png" style="background:url(../../assets/Information/zx15.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:355px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">（图、文</span><span style="font-family:Calibri">/ </span><span style="font-family:宋体">谭庆、柯学）</span></span>
</p>
<p>
    <span style=";font-family:Calibri;font-size:14px">&nbsp;</span>
</p>
<p>
    <br/>
</p>



  </div>

</template>
<script>

  import router from '@/router'

  export default {
    components: {

    },
    data() {
      return {
        htmls:''

      }
    },
    created(){

    },
    methods:{


    }
  }
</script>
<style lang="sass">

</style>

